function positionToLineCol(source: string, position: number): { line: number; column: number } {
  let line = 1
  let column = 1
  for (let i = 0; i < position && i < source.length; i += 1) {
    if (source[i] === '\n') {
      line += 1
      column = 1
    } else {
      column += 1
    }
  }
  return { line, column }
}

function levenshtein(a: string, b: string): number {
  if (a === b) return 0
  if (!a.length) return b.length
  if (!b.length) return a.length

  const rows = a.length + 1
  const cols = b.length + 1
  const matrix: number[][] = Array.from({ length: rows }, () => Array(cols).fill(0))

  for (let i = 0; i < rows; i += 1) matrix[i][0] = i
  for (let j = 0; j < cols; j += 1) matrix[0][j] = j

  for (let i = 1; i < rows; i += 1) {
    for (let j = 1; j < cols; j += 1) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1
      matrix[i][j] = Math.min(
        matrix[i - 1][j] + 1,
        matrix[i][j - 1] + 1,
        matrix[i - 1][j - 1] + cost
      )
    }
  }

  return matrix[rows - 1][cols - 1]
}

export function parseJsonWithDetailedError(source: string): { value?: unknown; error?: string } {
  try {
    return { value: JSON.parse(source) }
  } catch (error) {
    const rawMessage = error instanceof Error ? error.message : 'JSON inválido.'
    const positionMatch = rawMessage.match(/position\s+(\d+)/i)
    if (!positionMatch) {
      return { error: `Error de sintaxis JSON: ${rawMessage}` }
    }

    const position = Number(positionMatch[1])
    const { line, column } = positionToLineCol(source, position)
    return {
      error: `Error de sintaxis JSON en línea ${line}, columna ${column}: ${rawMessage}`,
    }
  }
}

export function unknownKeyMessages(
  record: Record<string, unknown>,
  allowedKeys: readonly string[],
  pathLabel: string
): string[] {
  const allowed = new Set(allowedKeys)
  const messages: string[] = []

  Object.keys(record).forEach((key) => {
    if (allowed.has(key)) return
    let suggestion = ''
    let minDistance = Number.POSITIVE_INFINITY
    allowedKeys.forEach((candidate) => {
      const distance = levenshtein(key, candidate)
      if (distance < minDistance) {
        minDistance = distance
        suggestion = candidate
      }
    })
    if (suggestion && minDistance <= 3) {
      messages.push(`Clave no admitida en ${pathLabel}: \`${key}\`. ¿Quisiste decir \`${suggestion}\`?`)
      return
    }
    messages.push(`Clave no admitida en ${pathLabel}: \`${key}\`.`)
  })

  return messages
}

